// 权限配置
import request from '@/utils/request'

export default function (callfn) {
  let {fuserId}=JSON.parse(localStorage.getItem("userInfo")||JSON.stringify({}));
  if(fuserId){
    return request({
      url: '/mall/mallmanage/demanduserdepart/queryDemanduserdepartInfo?FID='+fuserId,
      method: 'post'
    }).then(res=>{
      callfn&&callfn(res)
    })
  }else{
    callfn&&callfn({data:[]})
  }

}